import { z } from 'zod';
import { isAllowedPartnerRedirect } from './safeRedirect';

const partnerPrefillSchema = z
    .object({
        partnerRedirectUrl: z.string().optional(),
        partnerInfo: z.record(z.string(), z.unknown()).optional(),
    })
    .passthrough()
    .superRefine((data, ctx) => {
        const url = data.partnerRedirectUrl;
        if (url && !isAllowedPartnerRedirect(url)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'partnerRedirectUrl is not allowlisted',
                path: ['partnerRedirectUrl'],
            });
        }
    });

export function parsePartnerPrefill(data: unknown) {
    return partnerPrefillSchema.safeParse(data);
}
